//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('ecommerceIntegrationsConnectingAsync', {
    bindings: {
      continueCallback: '&',
      goBackCallback: '&',
      quitCallback: '&',
    },
    template: require('@legacy-components/ecommerce-integrations/ecommerce-integrations-connecting-async.html'),
    controller: [
      'EcommerceIntegrationsAsyncStatusState',
      'EcommerceIntegrationsService',
      function(
                EcommerceIntegrationsAsyncStatusState,
                EcommerceIntegrationsService,
            ) {
        this.connectingStates = EcommerceIntegrationsAsyncStatusState;

        this.connectingState = this.connectingStates.NOT_CONNECTING;
        this.progress = 'indeterminate';

        this.getProgress = () => {
          return this.progress;
        };

        this.$onInit = () => {
          EcommerceIntegrationsService.store.subscribe((store) => {
            this.connectingState = store.connectingState;
            this.progress = store.progress;
          });
        };
      }],
  });
})();
